<script setup lang="ts">
import BoyIcon from '@/assets/icons/BoyIcon.vue';
</script>

<template>
  <div class="rounded-full size-cell flex items-center justify-center shrink-0 mr-[20px]">
    <span class="size-[44px] rounded-full bg-surface-border flex items-center justify-center shrink-0">
      <BoyIcon class="size-[60%] text-black" />
    </span>
  </div>
</template>
